/* global CONFIG */
import moment from 'moment'
import services from '../services'
import ft from '../featureToggle'

export default {
  getTransactions (VueApp, conId, callback) {
    let self = this
    let transactions = VueApp.$store.state.consumer.reservations
    let pageSize = transactions.perPage
    let page = transactions.currentPage
    let pickupSince = moment(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00')
    let pickupUntil = moment(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59')
    if (transactions.date === 'all') {
      pickupSince = '2010-01-01 00:00'
      pickupUntil = moment().add(10, 'years').format('YYYY-MM-DD 23:59')
    }

    VueApp.$sdk.get('/consumer/' + conId + '/rsvp', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page + 1,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: pickupSince,
      until: pickupUntil,
      search: transactions.search,
      status: transactions.status
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('consumer/setReservationsCurrentPage', page + 1)

        if (res.list.length < pageSize) {
          VueApp.$store.commit('consumer/setReservationsIsMax', true)
        }

        if (res.list.length) {
          let rsvp = res.list
          for (let i = 0; i < res.list.length; i++) {
            let provider = rsvp[i].provider
            // let consumer = rsvp[i].consumer
            let payment = rsvp[i].payment
            let fareAmount = payment.fareAmount
            if (rsvp[i].status !== 'complete' && rsvp[i].optinShared.isOptinShared && rsvp[i].optinShared.current === 'shared') {
              fareAmount = rsvp[i].optinShared.exclusive.amount
            }
            let totalFare = fareAmount + payment.pickupFee + payment.tipAmount + rsvp[i].travelInsurance + rsvp[i].gasFee
            if (rsvp[i].airportFee !== null) {
              totalFare = totalFare + rsvp[i].airportFee
            }

            let pickup = rsvp[i].pickupLocation.geofenceType === 'airport' ? rsvp[i].pickupLocation.geofenceName : rsvp[i].pickupLocation.title
            let dropoff = rsvp[i].dropoffLocation.geofenceType === 'airport' ? rsvp[i].dropoffLocation.geofenceName : rsvp[i].dropoffLocation.title

            VueApp.$store.commit('consumer/addReservations', {
              date: moment(rsvp[i].created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
              providerId: provider.id,
              company: provider.businessName,
              rsvpId: rsvp[i].ID,
              pkgId: rsvp[i].packageId,
              type: rsvp[i].isAsap ? 'asap' : 'rsvp',
              status: rsvp[i].dispatchStatus,
              // firstName: consumer.firstName,
              // lastName: consumer.lastName,
              // mobile: consumer.phone,
              creditCard: rsvp[i].cardNumber,
              bookedThrough: self.bookedThroughLabel(rsvp[i].deviceType),
              finalOffer: self.toFixed(payment.offer),
              chargedAmount: self.toFixed(payment.charged),
              promoUsed: self.toFixed(payment.credit),
              statusLabel: rsvp[i].status,
              paymentURL: rsvp[i].paymentURL,
              externalId: rsvp[i].externalId || '',
              pickupTime: moment(rsvp[i].pickupDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
              pickupLocation: pickup,
              dropoffLocation: dropoff,
              service: rsvp[i].serviceType,
              pax: rsvp[i].passengers,
              luggage: rsvp[i].luggage,
              flightNumber: rsvp[i].flightNumber || '',
              airline: rsvp[i].airline || '',
              fare: self.toFixed(totalFare) || '',
              flight: rsvp[i].airline && rsvp[i].flightNumber ? rsvp[i].airline +' '+ rsvp[i].flightNumber : 'N/A',
              isCharter: rsvp[i].isCharter
            })
          }
        }
      }
      callback(res)
    })
  },
  exportTransactions (VueApp, conId, callback) {
    let self = this
    let transactions = VueApp.$store.state.consumer.reservations
    let pageSize = 99999
    let page = 1

    let since = moment(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00')
    let until = moment(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59')
    if (transactions.date === 'all') {
      since = '2010-01-01 00:00'
      until = moment().add(10, 'years').format('YYYY-MM-DD 23:59')
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: transactions.search,
      status: transactions.status,
      export: true
    }, res => {
      if (!res.error) {
        let rsvp = []
        if (res.list.length) {
          res.list.forEach(function (value) {
            rsvp.push(self.buildExport(value))
          })
        }
        callback(rsvp)
      } else {
        callback(res)
      }
    })
  },
  toFixed (value) {
    value = parseFloat(value)
    if (value < 0) {
      return '-$' + Math.abs(value).toFixed(2)
    }
    return '$' + value.toFixed(2)
  },
  bookedThroughLabel (value) {
    switch (value) {
      case 'ww': return 'Web'
      case 'admin': return 'Admin'
      case 'android': return 'Android App'
      case 'ios': return 'iOS App'
      case 'provider': return 'Provider'
      default: return value
    }

    return ''
  },
  buildExport (data) {
    let rsvpId = this.convertBrand(data.brandId) + data.rsvpId
    let serviceType = services.getServiceName(data.serviceCode)
    let payment = data.payment
    let creditCard = payment.cancelFee ? 'N/A' : data.cardNumber
    let source = this.bookedThroughLabel(data.deviceType)
    let provLicense = data.provider.accountType || ''

    if (data.packageId) {
      rsvpId = data.packageId
      serviceType = services.getServiceName('shared')
      source = 'PKG'
    }
    if (!CONFIG.useOldQuatation) {
      serviceType = data.serviceType.label
    }

    return {
      Date: moment(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
      'Booking Time': moment(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('HH:mm:ss'),
      'Pickup Time': moment(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      'Service Area': data.geofence.name,
      'Prov ID': data.provider.id,
      'Prov License': provLicense.toUpperCase(),
      'Company': data.provider.businessName,
      'RSVP ID': rsvpId,
      'Invoice ID': data.eventId,
      'Service Type': serviceType,
      'First Name': data.consumer.firstName,
      'Last Name': data.consumer.lastName,
      'Credit Card': creditCard,
      'Email': data.consumer.email,
      'Mobile': data.consumer.phone,
      'Source': source,
      'Final Offer': payment.offer || 0,
      'Charge Amount': payment.charged || 0,
      'Refunded Amount': -Math.abs(data.refundedAmount) || 0,
      'Promo Used': payment.credit || 0,
      'Driver Payment': payment.driverPay || 0,
      'Bonus': payment.bonus || 0,
      'Cancel Fees': payment.cancelFee || 0,
      'Status': data.status,
      'Pickup Location': data.pickupLocation,
      'Dropoff Location': data.dropoffLocation
    }
  },
  convertBrand (id) {
    let index = CONFIG.brands.findIndex(x => x.id === id)
    if (!id || index === -1) { return CONFIG.brands[0].code.toUpperCase() }

    return CONFIG.brands[index].code.toUpperCase()
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/consumer/reservations.js